export const LoginContainerStyle = `
  display: flex;
  height: 100%;
  background-color: #607d84;
  justify-content: center;
  align-items: center;  
`;
